import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = {
  class: "header-filters",
  gap: 28
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "PPC Management", -1);
const _hoisted_4 = {
  class: "toolbar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_v2_filters = _resolveComponent("ppc-v2-filters");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_period_controllers = _resolveComponent("period-controllers");
  const _component_PPCSettingsTabs = _resolveComponent("PPCSettingsTabs");
  const _component_strategic_period_table = _resolveComponent("strategic-period-table");
  const _component_tabbed_kpi_cards = _resolveComponent("tabbed-kpi-cards");
  const _component_performance_period_table = _resolveComponent("performance-period-table");
  const _component_ppc_settings = _resolveComponent("ppc-settings");
  const _component_wrap_with_overlay = _resolveComponent("wrap-with-overlay");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_product_table = _resolveComponent("product-table");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    "content-padding": "0",
    class: _normalizeClass(['advertising-v2', _ctx.currentTabValue]),
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.openModal = $event),
    activateSettings: $data.activateSettings,
    rightStripFeatureName: $data.rightStripFeatureName,
    hideSettingsFooterButtons: $data.hideSettingsFooterButtons,
    settingsInfo: "Advertising Settings can only be opened when you have a single seller and marketplace."
  }, {
    topbar: _withCtx(({
      breadcrumbs
    }) => [_createElementVNode("div", _hoisted_1, [_createTextVNode(_toDisplayString(breadcrumbs) + " ", 1), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_ppc_v2_filters, {
      secondaryFilterInitializers: $data.secondaryFilterInitializers
    }, null, 8, ["secondaryFilterInitializers"])]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_filter, {
      currencies: _ctx.currencies,
      "only-mode": "",
      onApply: $options.handleApplyForCurrencyChange
    }, null, 8, ["currencies", "onApply"])], 512), [[_vShow, !_ctx.ppcV2UserOnSettingsPage()]])])]),
    "topbar-sub": _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["navigation-wrapper", [_ctx.currentTabValue]])
    }, [_createVNode(_component_navigation_tabs, {
      tabs: $options.getAdvertisingTabs(),
      modelValue: $options.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event),
      class: "navigation-tabs-ppc"
    }, null, 8, ["tabs", "modelValue"]), _withDirectives(_createVNode(_component_period_controllers, {
      period: $options.period,
      "onUpdate:period": _cache[1] || (_cache[1] = $event => $options.period = $event),
      periodCategory: $options.periodCategory,
      "onUpdate:periodCategory": _cache[2] || (_cache[2] = $event => $options.periodCategory = $event),
      periodOptions: $options.periodOptions,
      periodSelectorOptions: _ctx.periodSelectorOptions
    }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"]), [[_vShow, _ctx.floatingTableState === $data.FLOATING_COMPOUND_TABLE_STATES.FULL_SIZE || _ctx.currentTabValue == 'strategic']]), _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(['tab-container', {
        disabled: $options.pausedPpcAutomationStatus
      }])
    }, [_createVNode(_component_PPCSettingsTabs, {
      tabs: $options.getSettingsTabs(),
      modelValue: $options.computedCurrentSettingsTab,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.computedCurrentSettingsTab = $event),
      disabled: $options.pausedPpcAutomationStatus,
      status: $data.ppcAutomationStatus,
      ppc_initialized: $data.ppcAutomationStatus,
      onEnable: $options.enablePPCAutomation,
      onPause: $options.pausePPCAutomation
    }, null, 8, ["tabs", "modelValue", "disabled", "status", "ppc_initialized", "onEnable", "onPause"])], 2), [[_vShow, _ctx.currentTabValue == 'settings']])], 2)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["ppc-v2-contents", [_ctx.floatingTableState, _ctx.currentTabValue]])
    }, [_createVNode(_component_flex_column, {
      class: _normalizeClass(['all-wrapper', _ctx.currentTabValue]),
      gap: 24
    }, {
      default: _withCtx(() => [_ctx.currentTabValue == 'strategic' ? (_openBlock(), _createBlock(_component_strategic_period_table, {
        key: 0,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTablePeriod,
        onRefresh: $options.refreshPeriodTable
      }, null, 8, ["loading", "onSetDateRange", "onRefresh"])) : _ctx.currentTabValue === 'performance' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_tabbed_kpi_cards, {
        kpi: _ctx.kpis_v2['performance'],
        loading: $data.kpisLoading
      }, null, 8, ["kpi", "loading"]), _createVNode(_component_performance_period_table, {
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTablePeriod,
        onRefresh: $options.refreshPeriodTable
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[4] || (_cache[4] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[5] || (_cache[5] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange", "onRefresh"])], 64)) : (_openBlock(), _createBlock(_component_wrap_with_overlay, {
        key: 2,
        overlay: $options.pausedPpcAutomationStatus,
        customClass: "ppc-settings-wrap-with-overlay"
      }, {
        default: _withCtx(() => [_createVNode(_component_ppc_settings, {
          ref: "ppcSettingsPage",
          activateSettings: $data.activateSettings,
          currentTab: $data.settingsTabs[$data.currentSettingsTab],
          onGoToTab: $options.goToTab
        }, null, 8, ["activateSettings", "currentTab", "onGoToTab"])]),
        _: 1
      }, 8, ["overlay"]))]),
      _: 1
    }, 8, ["class"]), _ctx.currentTabValue !== 'settings' ? (_openBlock(), _createBlock(_component_product_table, {
      key: 0,
      onRefresh: _cache[6] || (_cache[6] = $event => $options.handleProductTableRefresh()),
      loading: $data.productTableLoading,
      onHandleSort: $options.handleProductTableSort,
      onToggleMoreFilters: $options.handleMoreFilters,
      onChangeDate: $options.handleDateChange,
      onRefreshOtherKpis: _cache[7] || (_cache[7] = $event => this.refreshMediator(['KPIS', 'PERIOD_TABLE'])),
      onRefreshEvolutionTable: $options.refreshPeriodTable,
      onRestoreEvolutionTable: $options.restoreEvolutionTable,
      secondaryFilterInitializers: $data.secondaryFilterInitializers
    }, null, 8, ["loading", "onHandleSort", "onToggleMoreFilters", "onChangeDate", "onRefreshEvolutionTable", "onRestoreEvolutionTable", "secondaryFilterInitializers"])) : _createCommentVNode("", true)], 2)]),
    _: 1
  }, 8, ["class", "modelValue", "activateSettings", "rightStripFeatureName", "hideSettingsFooterButtons"]);
}